import React from 'react';
import MaterialsSection from 'components/quote_builder_widget/shared/MaterialsSection';
import HotStampingMachinesSection from 'components/quote_builder_widget/sections/HotStampingMachinesSection';
import HotStampingPrintingBlockSection from 'components/quote_builder_widget/sections/HotStampingPrintingBlockSection';
import SectionMenuLayout, { activeSubsection } from 'components/quote_builder_widget/shared/SectionMenuLayout';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

// The widget settings' Yaldız tab: the hot stamping materials visitors choose from (each with the name they see), the
// hot stamping machines the widget prices on, and the one printing block (klişe) it prices with.
const HotStampingMaterialsSection = ({ onChange }) => (
  <MaterialsSection materialType="hot_stamping_material" translationPrefix="hot_stamping" onMaterialsChange={onChange} />
);

const HOT_STAMPING_SECTIONS = [
  { id: 'hot_stamping_materials', label: 'quote_builder_widget.hot_stamping_menu_materials', Content: HotStampingMaterialsSection },
  { id: 'hot_stamping_machines', label: 'quote_builder_widget.hot_stamping_menu_machines', Content: HotStampingMachinesSection },
  { id: 'hot_stamping_printing_block', label: 'quote_builder_widget.hot_stamping_menu_printing_block', Content: HotStampingPrintingBlockSection },
];

const HotStampingSection = ({ activeSection, onSectionChange, onChange }) => {
  const active = activeSubsection(HOT_STAMPING_SECTIONS, activeSection);
  const { Content } = active;

  return (
    <SectionMenuLayout
      label={t('quote_builder_widget.section_hot_stamping')}
      sections={HOT_STAMPING_SECTIONS}
      activeId={active.id}
      onSectionChange={onSectionChange}
    >
      <div className={styles.fieldGroup}>
        <Content key={active.id} onChange={onChange} />
      </div>
    </SectionMenuLayout>
  );
};

export default HotStampingSection;
